<template>
  <div class="mb-4">
    <validation-observer ref="mcObserver" v-slot="{ errors }">
      <validation-provider :rules="{ required: !isOptional, requiredOptionText: {question, stateResponseTextValue} }" :disabled="isOptional" :debounce="1000" :immediate="validateImmediate">
        <div v-for="(error, name) in errors" :key="name">
          <h6 v-if="displayError(error, number + question.questionText)" class="text-danger">{{ error[0] }}</h6>
        </div>
        <label class="mb-1" :style="{ 'background-color': questionBackColor }" :for="`${_uid}-options`"><span v-html="number" class="number-text"></span><span v-html="question.questionText"></span></label>
        <div v-html="question.instructions" class="font-italic mb-1"></div>
        <div v-if="debugQuestions" class="text-warning">{{ question.hspCategoryQuestionId }} (state: {{ stateResponse }})</div>
        <el-select
          :id="`${_uid}-options`"
          :class="[`select-${colorScheme}`, 'select-border']"
          :style="{ 'background-color': responsesBackColor }"
          size="large"
          placeholder="Please select an option."
          v-model="stateResponse"
          @change="onSelectChange">
            <el-option
              v-for="response in question.responses"
              :class="`select-${colorScheme}`"
              :value="response.hspResponseId"
              :label="response.responseShortTitle ? response.responseShortTitle : response.responseTitle"
              :key="response.hspResponseId">
              <span v-html="response.responseTitle"></span>
            </el-option>
        </el-select>
        <div class="mt-1" v-if="isOfResponseType(2)">
          <base-input v-model="textModel"></base-input>
        </div>
        <div class="mt-1" v-else-if="isOfResponseType(3)">
          <base-input v-model="textModel" :isMultiline="true"></base-input>
        </div>
      </validation-provider>
    </validation-observer>
  </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { Select, Option } from 'element-ui';
import { mapGetters } from 'vuex';

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    [Select.name]: Select,
    [Option.name]: Option
  },
  props: {
    question: Object,
    number: String,
    questionBackColor: String,
    responsesBackColor: String,
    sectionId: {
      type: Number,
      required: true,
      description: 'Needed to disable validation when section is not active.'
    },
    validateImmediate: Boolean,
  },
  computed: {
    ...mapGetters([
      'colorScheme',
      'activeSectionId',
      'debugQuestions'
    ]),
    isDisplayed() {
      return this.sectionId === this.activeSectionId;
    },
    isOptional() {
      if (this.isDisplayed && this.question.isRequired === true) {
        return false;
      }

      return true;
    },
    stateResponse: {
      get() {
        return this.$store.getters.getQuestionResponseId(this.question.hspCategoryQuestionId);
      },
      set(value) {
        this.$store.dispatch('setQuestionResponse', {
          questionTypeId: this.question.hspQuestionTypeId,
          questionId: this.question.hspCategoryQuestionId,
          responseId: value
        });
      }
    },
    selectedResponse() {
      if (!this.stateResponse) {
        return null;
      }

      let response = this.question.responses.find(response => response.hspResponseId == this.stateResponse);
      return response ? response : null;
    },
    selectedResponseType() {
      return this.selectedResponse ? this.selectedResponse.hspResponseTypeId : null;
    },
    stateResponseTextValue() {
      let responses = this.$store
        .getters
        .getQuestionResponses(this.question.hspCategoryQuestionId)
        .filter(response => response.hspResponseTypeId == 2 || response.hspResponseTypeId == 3);

      if (responses.length) {
        return responses[0].responseTextValue;
      }

      return null;
    },
    hasResponseTriggers() {
      return this.question.responseTriggers.length > 0;
    },
    textModel: {
      get() {
        return this.stateResponseTextValue;
      },
      set(value) {
        this.handleTextChange(value);
      }
    },
  },
  methods: {
    displayError(error, description = "") {
      let display = error.length > 0 && error[0].length > 0;
      // console.log("In Dropdown.vue -- error:");
      // console.log(error);
      // console.log((description.length > 0 ? "for [" + description + "]: " : "") + "display = [" + display + "]");
      return display;
    },
    onSelectChange() {
      let s = this.selectedResponse;
      // Clear the item text if the selected item is not a text input type.
      if (s && [2,3].indexOf(s.hspResponseTypeId) === -1) {
        this.textModel = null;
      }

      this.handleResponseTriggers(this.stateResponse);
      this.$refs.mcObserver.reset();
    },
    handleTextChange(value) {
      this.$store.dispatch('setCheckboxTextResponse', {
        questionTypeId: this.question.hspQuestionTypeId,
        questionId: this.question.hspCategoryQuestionId,
        responseId: this.stateResponse,
        isExclusive: false,
        hasTextField: true,
        responseText: value
      });
    },
    handleResponseTriggers(value) {
      if (!this.hasResponseTriggers) {
        return;
      }

      let responseTrigger = this.question.responseTriggers.find(trigger => trigger.triggerResponseId === value);

      if (responseTrigger) {
        this.$store.dispatch('setTargetSection', responseTrigger);
      }
      else {
        this.$store.dispatch('clearTargetSectionId', this.sectionId);
        this.$emit('triggercleared');
      }
    },
    isOfResponseType(responseTypeId) {
      if (!this.isDisplayed) {
        return false;
      }

      return this.selectedResponseType == responseTypeId;
    },
  },
  watch: {
    isDisplayed: function(value) {
      // 11/21/2022, msc: Don't know if this watch is necessary because response triggers seem to work without it.
      // However, it doesn't hurt to (re)handle the response trigger when the user navigates back to an active page with a dropdown that has response logic.
      if (value === true) {
        this.handleResponseTriggers(this.stateResponse);
      }
    }
  },
}
</script>
<style scoped="true">
.select-border {
  border-top-left-radius: 0.4285rem;
  border-bottom-left-radius: 0.4285rem;
  border-top-right-radius: 0.4285rem;
  border-bottom-right-radius: 0.4285rem;
}
</style>
